import React from "react";
import { TextField, Autocomplete } from "@mui/material";
import { useField } from "formik";

const AutocompleteWrapper = ({ name, options, label, id, ...otherProps }) => {
  const [field, mata] = useField(name);
  // eslint-disable-next-line no-unused-vars

  const configAutocomplete = {
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
  };

  if (mata && mata.touched && mata.error) {
    configAutocomplete.error = true;
    configAutocomplete.helperText = mata.error;
  }

  const configTextField = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
    //onChange: handleChange,
  };

  if (mata && mata.touched && mata.error) {
    configTextField.error = true;
    configTextField.helperText = mata.error;
  }

  return (
    <Autocomplete
      options={options}
      id={id}
      getOptionLabel={(option) => option.label}
      {...configAutocomplete}
      renderInput={(params) => (
        <TextField {...params} {...configTextField} label={label} />
      )}
      autoComplete="off"
    />
  );
};

export default AutocompleteWrapper;
